
import HolidayOperationForm from '@/components/Projects/Holidays/HolidayOperationForm';
import AddNewElementButton from '@/components/Common/AddNewElementButton';
import HolidaysListItem from './HolidaysListItem';
import HolidayListSearchPanel from './HolidayListSearchPanel';
import { hDeepCopy } from '@/utils/helpers';

export default {
  name: 'HolidaysList',

  components: {
    HolidayOperationForm,
    AddNewElementButton,
    HolidaysListItem,
    HolidayListSearchPanel,
  },
  props: {
    projectUuid: {
      type: String,
      default: () => ({}),
    },
  },

  data() {
    return {
      isModalVisible: false,
      editableHoliday: undefined,
      PAGE_SIZE_OPTIONS: [1, 20, 50, 100],
      holidaysPerPage: 20,
      currentPage: 1,
      filterBy: {
        element: '',
        type: '',
        status: '',
      },
    };
  },

  watch: {
    filterBy: {
      handler() {
        this.currentPage = 1;
      },
      deep: true,
    },
    holidaysPerPage: {
      handler() {
        this.currentPage = 1;
      },
    },
  },

  async created() {
    window.addEventListener('resize', this.debounce(this.windowWidthChanged));
    this.windowWidthChanged();
    await this.$store.dispatch('client/project/holidays/getList', this.projectUuid);
  },
  destroyed() {
    window.removeEventListener('resize', this.windowWidthChanged);
  },

  computed: {
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'client/project/holidays/getList',
      ]);
    },
    holidaysList() {
      return this.$store.getters['client/project/holidays/list'].records;
    },
    holidaysListFiltered() {
      let holidays = hDeepCopy(this.holidaysList);
      if (this.filterBy.element) {
        holidays = holidays.filter(holiday => holiday.element === this.filterBy.element);
      }
      if (this.filterBy.type) {
        holidays = holidays.filter(holiday => holiday.type === this.filterBy.type);
      }
      if (this.filterBy.status) {
        holidays = holidays.filter(holiday => holiday.holiday_status === this.filterBy.status);
      }
      return holidays;
    },
    holidaysToRenderPerPage() {
      return this.holidaysListFiltered.slice(
        (this.currentPage - 1) * this.holidaysPerPage,
        this.currentPage * this.holidaysPerPage,
      );
    },
    isFiltered() {
      return this.filterBy.element || this.filterBy.type || this.filterBy.status;
    },

  },

  methods: {
    openCreateOrEditForm(holiday) {
      this.editableHoliday = holiday ? hDeepCopy(holiday) : undefined;
      this.toggleModalVisible();
    },
    toggleModalVisible() {
      this.isModalVisible = !this.isModalVisible;
    },
    handleRefreshList() {
      this.$store.dispatch('client/project/holidays/getList', this.projectUuid);
    },
    async handleChangePage(page) {
      this.currentPage = page;
    },
    changeFilterBy(value) {
      this.filterBy = value;
    },
    windowWidthChanged() {
      if (window.innerWidth >= 1470 && window.innerWidth < 1935) {
        this.PAGE_SIZE_OPTIONS = [9, 18, 27, 60, 99];
        this.holidaysPerPage = 18;
      } else {
        this.PAGE_SIZE_OPTIONS = [10, 20, 50, 100];
        this.holidaysPerPage = 20;
      }
    },
    debounce(func, timeout = 300) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
      };
    },
  },
};
